import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Route } from "react-router-dom";

import Invoice1 from "./Invoice1";

const SampleInvoices = () => {
  return (
    <div style={{ height: "100vh" }}>
      {process.env.NODE_ENV === "development" && (
        <>
          <Route
            path="/sample/invoice1"
            render={() => (
              <iframe
                title={document.title}
                srcDoc={renderToStaticMarkup(<Invoice1 />)}
                width="100%"
                height="100%"
              />
            )}
          />
        </>
      )}
    </div>
  );
};

export default SampleInvoices;
